<template>
  <div class="w-full">
    <div class="flex items-center">
      <h2 class="text-left text-lg font-normal">
        {{ $t('manager.discoverCommunityContent') }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
